import { Injectable } from '@angular/core';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PartsService {
  private rootUrl: string;
  private partsAPIUrl;

  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.partsAPIUrl = ApiConfig.PartsApiConfig;
   }

	deleteModelParts(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.deleteModelParts}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	removeModelFromVendor(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.removeModelFromVendor}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
  getModelParts(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.getModelParts}`, partsObj )
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	GetPartByPartId(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.GetPartByPartId}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getPartModels(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.getPartModels}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getPartManufacturers(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.getPartManufacturers}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getParts(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.getParts}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getPartGroups(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.getPartGroups}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	isPartUnderWarranty(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.isPartUnderWarranty}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	isPartUnique(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.isPartUnique}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	createAdHocPart(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.createAdHocPart}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	assignModelsToParts(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.assignModelsToParts}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	updatePartModels(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.updatePartModels}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	assignModelsToVendor(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.assignModelsToVendor}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	searchParts(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.searchParts}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	updatePartDetail(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.updatePartDetail}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	mergePart(partsObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.partsAPIUrl.mergePart}`, partsObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}



}
